<template>
  <div>
    <div class="d-flex align-items-center" style="margin-top: 12px;">
      <div>
        <h5 class="mb-0">Словарь 1С (Бюджет)</h5>
        <div class="fs12px lh12px">
          <em>
            Данный словарь используется для создания статей бюджета с привязкой к свойствам 1С. Поиск осуществляется по полному совпадению со стройкой выгрузки из 1С, либо с частичным совпадением, если точного не нашлось.
          </em>
        </div>
      </div>
      <div class="d-flex ml-auto">
        <div>
          <input class="form-control table-input-search" type="search" placeholder="Поиск" v-model="filter">
        </div>
        <b-button
          @click="getDictionary()"
          size="sm"
          variant="outline-secondary"
          class="ml-2"
          :disabled="loading"
        >
          <b-icon icon="arrow-repeat" scale="1.5" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
        <button
          :disabled="loading"
          @click="openCreate()"
          class="btn btn-outline-primary ml-2"
        >
          Создать запись
        </button>
      </div>
    </div>
    <h5 class="mt-5 mb-4">Список значений</h5>
    <Bdr2026OneCProperties
      :records="filtredItems"
      @update-item="getDictionary"
    />
    <Bdr2026OneCSidebar
      :isOpen.sync="isOpen"
      :editedItem.sync="editedItem"
      @updateItem="getDictionary"
    />
  </div>
</template>

<script>
import { API_BDR2026_1C_DICTIONARY } from '@/constants';
import Bdr2026OneCProperties from '@/components/bdrPage/Bdr2026OneCProperties.vue';
import Bdr2026OneCSidebar from '@/components/bdrPage/Bdr2026OneCSidebar.vue';

export default {
  name: 'BDR2026OneCdictionary',
  components: {
    Bdr2026OneCProperties,
    Bdr2026OneCSidebar
  },
  data() {
    return {
      loading: false,
      dictionary: [],
      filter: '',
      isOpen: false,
      editedItem: {
        name_from_file: '',
        bdr2026_dictionary_id: null,
        unit_percent: '',
        always_pass: 0,
        property: {}
      }
    };
  },
  computed: {
    filtredItems() {
      if (!this.filter) return this.dictionary;
      const search = this.filter.toLowerCase();
      return this.dictionary.filter(item => this.matchesSearch(item, search));
    }
  },
  mounted() {
    this.getDictionary();
  },
  methods: {
    getDictionary() {
      this.loading = true;
      axios.get(`${API_BDR2026_1C_DICTIONARY}?easylist=true`).then(({ data }) => {
        this.dictionary = data || [];
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    matchesSearch(item, search) {
      if (item.name_from_file && item.name_from_file.toLowerCase().includes(search)) return true;
      if (item.property && item.property.name && item.property.name.toLowerCase().includes(search)) return true;
      return false;
    },
    openCreate() {
      this.editedItem = {
        name_from_file: '',
        bdr2026_dictionary_id: null,
        unit_percent: '',
        always_pass: 0,
        property: {}
      };
      this.isOpen = true;
    }
  }
};
</script>
